import { h, Component } from 'preact';

import './index.less';
import EventBus from '../../lib/EventBus';
import Search from '../../molecules/Icon/Search';
import { cdnHost } from '../../../config';
import { addClass, removeClass } from '../../lib/Dom';

class AddressPicker extends Component {
  state = {
    selectedAddressValue: '',
    searchTerm: '',
    isVisible: false,
    placeHolderText: '',
    listEndComponent: null
  };

  componentDidMount () {
    EventBus.addListener(EventBus.TYPE.SHOW_ADDRESS_PICKER, this.onShow);
    EventBus.addListener(EventBus.TYPE.HIDE_ADDRESS_PICKER, this.onHide);
    EventBus.addListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
  }

  componentDidUpdate (previousProps, previousState) {
    const { isVisible, selectedAddressValue } = this.state;

    if (selectedAddressValue && this.addressListRef) {
      const countryItemElement = document.querySelector(
        `.country-item-${selectedAddressValue.replace(/ /g, '')}`
      );

      if (countryItemElement) {
        this.addressListRef.scrollTo(
          0,
          countryItemElement.offsetTop - this.addressListRef.offsetTop
        );
      }
    }

    if (isVisible && !previousState.isVisible && this.searchInput) {
      this.searchInput.focus();
    }
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.SHOW_ADDRESS_PICKER, this.onShow);
    EventBus.removeListener(EventBus.TYPE.HIDE_ADDRESS_PICKER, this.onHide);
    EventBus.removeListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
  }

  onShow = ({
    existingAddress,
    onSelect,
    addressList,
    placeHolderText,
    listEndComponent = null
  } = {}) => {
    this.onSelect = onSelect;
    this.addressComponentList = addressList;
    this.setState({
      selectedAddressValue: existingAddress || '',
      isVisible: true,
      placeHolderText,
      listEndComponent
    });
    addClass(document.querySelector('body'), 'block-scroll');
  };

  onHide = () => {
    removeClass(document.querySelector('body'), 'block-scroll');
    this.setState({
      isVisible: false,
      selectedAddressValue: '',
      searchTerm: '',
      placeHolderText: '',
      listEndComponent: null
    });
  };

  onRouteChange = () => {
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
  };

  onSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  onAddressComponentSelect = (addressData) => {
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
    this.onSelect(addressData);
  };

  onClosePress = () => {
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
  };

  getFilteredAddressList = () => {
    const { searchTerm } = this.state;

    if (!searchTerm) {
      return this.addressComponentList;
    }

    return this.addressComponentList.filter(
      (addressComponent) =>
        addressComponent.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
    );
  };

  render () {
    const { searchTerm, selectedAddressValue, isVisible, placeHolderText, listEndComponent } =
      this.state;

    if (!isVisible) {
      return <div />;
    }

    const addressComponentList = this.getFilteredAddressList();

    return (
      <div className="country-picker-container">
        <div className="country-picker">
          <div className="search-bar">
            <div className="search-icon">
              <Search size={20} color="#aaa" />
            </div>

            <div className="input-container">
              <input
                ref={(element) => (this.searchInput = element)}
                type="text"
                placeholder={placeHolderText}
                autoComplete="new-password"
                value={searchTerm}
                onInput={this.onSearchChange}
              />
            </div>

            <div className="close-icon" onClick={this.onClosePress}>
              <img alt src={`${cdnHost}assets/close-black.svg`} />
            </div>
          </div>

          <div ref={(element) => (this.addressListRef = element)} className="country-list">
            {addressComponentList.map((addressComponent) => (
              <div
                className={`country-item country-item-${addressComponent.name.replace(/ /g, '')} ${
                  selectedAddressValue === addressComponent.name ? 'selected' : ''
                }`}
                onClick={() => this.onAddressComponentSelect(addressComponent)}
              >
                <div className="name">{addressComponent.name}</div>
              </div>
            ))}
            {listEndComponent}
          </div>
        </div>
      </div>
    );
  }
}

export default AddressPicker;
